"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equalTo;

var _utils = require("../utils");

var _lib = require("../lib");

function equalTo(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = options.message,
      target = options.target;
  var defaultTarget = {
    label: 'Target',
    value: value
  };
  var currentTarget = defaultTarget;

  if ((0, _utils.checkValueExist)(target)) {
    (0, _utils.assertObject)(target, 'target');
    currentTarget = Object.assign(defaultTarget, target);
    (0, _utils.assertShape)(currentTarget, ['label', 'value'], 'target');
  }

  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);

  if (value !== currentTarget.value) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      target: currentTarget
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " does not match ").concat(currentTarget.label || 'Target'));
  }

  return validity;
}